<ion-searchbar
        [(ngModel)]="myInput"
        showCancelButton="never">
</ion-searchbar>
<div *ngIf="!showMap" class="about-header ion-text-center" style="position:absolute;width:100%">
    <h3 style="color:#fff" class="ion-text-center">{{'Loading.Map'}}</h3>
</div>
<div class="map-wrapper">
    <div id="map" #mapCanvas></div>
</div>
<div #setButton>
    <ion-button  (click)="setPlaceIntoData()" [hidden]="!showMap">{{'TakeoverLocation' | translate}}</ion-button>
</div>
<div #refreshButton>
    <ion-button (click)="refreshGeoData()" [hidden]="!showMap || showRefreshHidden">{{'Refresh' | translate}}</ion-button>
</div>
